import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Card, CardType } from '../../../../../_interfaces/cards.interface';
import { ActivatedRoute } from '@angular/router';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';
import { BlockConfirmationComponent } from '../../../../../shared/components/cards/block-card/block-confirmation/block-confirmation.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-block-employee-card-confirmation',
  imports: [BlockConfirmationComponent],
  templateUrl: './block-employee-card-confirmation.component.html',
})
export class BlockEmployeeCardConfirmationComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly cardsApiService = inject(CardsApiService);

  private readonly cardId: number;
  protected cardDetails?: Card;
  protected cardType: CardType = CardType.Personal;
  readonly subscriptions = new Subscription();

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit() {
    this.subscriptions.add(
      this.cardsApiService.getCardPersonalById(this.cardId).subscribe((data) => (this.cardDetails = data)),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
